import type { RootState } from "../reducers/root.reducer"
import type { IEmbedCalculatorState } from "../types/state.types"

export const embedCalculatorSelector = (
    state: RootState,
): IEmbedCalculatorState => state.embedCalculator
